<template>
	<div>
		<code-login ref="myCodeLogin" @update-page="updatePage"></code-login>
		<head-top head-title="章节练习" goBack="true"></head-top>
		<div class="con">
			<van-pull-refresh v-model="isLoading" @refresh="onRefresh">
				<!--九宫格块-->
				<div class="cateBox flex_b">
					<div class="cateItem flex_c" @click='gridJump("1")'>
						<img :src='resourceDomain+"static/icon/practice/cuotilianxi.png"'>
						<div>错题练习</div>
					</div>
					<div class="cateItem flex_c" @click='gridJump("2")'>
						<img :src='resourceDomain+"static/icon/practice/shoucang1.png"'>
						<div>我的收藏</div>
					</div>
					<div class="cateItem flex_c" @click='gridJump("3")'>
						<img :src='resourceDomain+"static/icon/practice/lianxijilu.png"'>
						<div>练习记录</div>
					</div>
				</div>

				<div class="chapter_title">
					章节练习
				</div>

				<div v-for="(item,index) in list" :key="item.id" class="chapter_item"
					@click='toPracticeChapterDetail(item.id,item.total)'>
					<div class="chaptername ellipsis_1">
						{{index+1}}. {{item.chapterName}}
					</div>

					<div class="flex_c chapterCell">
						<div style='width:75%;display: flex; flex-direction:column;'>
							<div class="flex_c answer_progress">
								<div style='flex:1; color:#666;text-align: left;'>{{item.userTotal}}/{{item.total}}</div>
								<div style='flex:1; text-align:right; color:#666;'>{{item.percent}}%</div>
							</div>
							<div>
								<van-progress :percentage="item.percent" stroke-width="3" track-color="#f3f3f3" color="#09BB07"
									:show-pivot="false" />
							</div>
						</div>

						<div class="flex_a" style='width:25%;justify-content: flex-end;'>
							<img :src='resourceDomain+"static/icon/practice/lianxi.png"' class="lianxiIcon">
						</div>
					</div>
				</div>
			</van-pull-refresh>
		</div>
	</div>
</template>

<script>
	import headTop from '@/components/common/head.vue'
	import api from '@/apis/api'
	import {
		mapGetters,
		mapActions
	} from 'vuex';
	export default {
		name: 'PracticeChapter',
		components: {
			headTop: headTop
		},
		data() {
			return {
				resourceDomain: api.resourceDomain,
				list: [], //我的题库集合
				id: 0,
				isLoading: false
			}
		},
		beforeRouteEnter(to, from, next) {
			// 添加背景色
			document.querySelector('body').setAttribute('style', 'background-color:#f5f5f5')
			next()
		},
		beforeRouteLeave(to, from, next) {
			// 去除背景色
			document.querySelector('body').setAttribute('style', '')
			next()
		},
		created() {},
		activated() {
			this.id = this.$route.query.id
			this.chapterListByPid()
		},
		methods: {
			// 调用组件中的登录成功里的自定义的更新数据事件
			updatePage() {
				this.chapterListByPid()
			},

			// 九宫格点击跳转
			gridJump(index) {
				if (index == 1) {
					this.$router.push({
						'path': '/practice_wrong'
					})
				} else if (index == 2) {
					this.$router.push({
						'path': '/practice_collection'
					})
				} else if (index == 3) {
					this.$router.push({
						'path': '/practice_chapter_history'
					})
				}
			},

			// 获取章节列表
			chapterListByPid() {
				this.$toast.loading({
					overlay: true,
					message: "加载中...",
					duration: 0,
				});
				api.get('/mp/practice/question/chapterListByPid', {
					chapterId: this.id,
				}).then(res => {
					this.$toast.clear();
					console.log(res, "---------------chapterListByPid");
					if (res.success) {
						this.list = res.data
					} else {
						this.$toast(res.message);
					}
				})
			},

			// 章节跳转具体题目界面
			toPracticeChapterDetail(id, total) {
				if (total > 0) {
					this.$router.push({
						'path': '/practice_chapter_detail',
						query: {
							id: id
						}
					})
				} else {
					this.$toast("该章节下没有题目");
				}
			},


			// 下拉刷新
			onRefresh() {
				this.chapterListByPid()
				this.isLoading = false
			},

		}
	}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
	.con {
		padding-top: 68px
	}

	// 九宫格
	.cateBox {
		background-color: #fff;
		margin: 0 auto 20px;
		width: 345px;
		padding: 15px 0;
		border-radius: 8px;
	}

	.cateItem {
		width: 33%;
		flex-direction: column;
	}

	.cateItem img {
		width: 50px;
		height: 50px;
		margin: 0 auto;
		display: block;
	}

	.cateItem div {
		font-size: 14px;
		margin-top: 10px;
		color: #666;
	}

	.chapter_title {
		width: 345px;
		font-size: 16px;
		margin: 0 auto 15px;
	}

	.chapter_item {
		background-color: #fff;
		margin: 0 auto 20px;
		width: 315px;
		text-align: center;
		padding: 10px 15px;
		font-size: 14px;
		border-radius: 8px;
		box-shadow: 0px 0px 20px 1px #D4D4D4;
	}

	.paddinga {
		text-align: center;
		padding: 15px 0;
	}

	.chaptername {
		margin-bottom: 10px;
		font-weight: 600;
		text-align: left;
		width: 100%;
	}

	.lianxiIcon {
		display: block;
		width: 50px;
		height: 50px;
	}

	.chapterCell {
		border-top: 1px dotted #e6e6e6;
		width: 100%;
		padding-top: 5px;
	}

	.answer_progress {
		padding-bottom: 10px;
		letter-spacing: 2px;
	}
</style>